import React, { useEffect, useState } from 'react'
import PropTypes from "prop-types";


const AttendanceView = ({ Emp_data }) => {

    const [Data, setData] = useState({
        approved_by: "",
        approver: "",
        date: "",
        outTime: "",
        department: "",
        employee: "",
        employee_id: "",
        id: "",
        incharge: '',
        mobile: "",
        inTime: "",
        total_workedTime: "",
        status: ""
    })

    function formatSimpleDate(dateStr) {
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    }

    const formatTime = (timeStr = "") => {
        if (!timeStr.includes(":")) return "";
        const [hour, minute] = timeStr.split(':');
        let h = parseInt(hour, 10);
        const m = minute || '00';
        const ampm = h >= 12 ? 'PM' : 'AM';
        h = h % 12 || 12;

        return `${h}:${m} ${ampm}`;
    };


    useEffect(() => {
        setData({
            approved_by: Emp_data.approved_by,
            approver: Emp_data.approver,
            date: Emp_data.date,
            outTime: Emp_data.outTime,
            department: Emp_data.department,
            employee: Emp_data.employee,
            employee_id: Emp_data.employee_id,
            id: Emp_data.id,
            incharge: Emp_data.incharge,
            mobile: Emp_data.mobile,
            inTime: Emp_data.inTime,
            total_workedTime: Emp_data.total_workedTime,
            status: Emp_data.status,
        })
    }, [Emp_data])


    return (
        <div
            className="modal custom-modal custom-lg-modal fade p-20"
            id="Attendance-view"
            role="dialog"
        >
            <div className="modal-dialog modal-dialog-centered modal-md">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <div className="form-header modal-header-title text-start d-flex align-items-center mb-0">
                            <h4 className="mb-0">Attendance Details</h4>
                        </div>
                        <button
                            type="button"
                            className="btn-close ms-2"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body pb-0">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-field-item">
                                    <div className="profile-picture company-detail-head">
                                        <div className="upload-profile">
                                            <div className="add-profile">
                                                <p>Status</p>
                                            </div>
                                        </div>
                                        <div>
                                            {Data.status === "approved"&&
                                                <span className="badge bg-success d-inline-flex align-items-center me-2">
                                                    <i className="fe fe-check me-1" />
                                                    {Data.status}
                                                </span>
                                            }
                                            {Data.status === "Denied" &&
                                                <span className="badge bg-danger d-inline-flex align-items-center me-2">
                                                    <i className="fe fe-check me-1" />
                                                    {Data.status}
                                                </span>
                                            }
                                            {Data.status === "Deleted" &&
                                                <span className="badge bg-warning d-inline-flex align-items-center me-2">
                                                    <i className="fe fe-check me-1" />
                                                    {Data.status}
                                                </span>
                                            }
                                               {Data.status === "applied" &&
                                                <span className="badge bg-secondary d-inline-flex align-items-center me-2">
                                                    <i className="fe fe-check me-1" />
                                                    {Data.status}
                                                </span>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="plane-basic-info">
                                    <h5>Basic Info</h5>
                                    <div className="row">
                                        <div className="col-md-4 col-sm-6">
                                            <div className="basic-info-detail">
                                                <h6>Name</h6>
                                                <p>{Data.employee}</p>
                                            </div>
                                            <div className="basic-info-detail">
                                                <h6>Mobile</h6>
                                                <p>{Data.mobile}</p>
                                            </div>
                                            {/* <div className="basic-info-detail">
                                                <h6>User Type</h6>
                                                <p>{Data.user_type}</p>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="plane-basic-info plane-detail">
                                    <h5>Attendance Info</h5>
                                    <div className="row">
                                        <div className="col-md-4 col-sm-6">
                                            <div className="basic-info-detail">
                                                <h6>Check In</h6>
                                                <p>{formatTime(Data.inTime)}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6">
                                            <div className="basic-info-detail">
                                                <h6>Check Out</h6>
                                                <p>{formatTime(Data.outTime)}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6">
                                            <div className="basic-info-detail">
                                                <h6>Date</h6>
                                                <p>{formatSimpleDate(Data.date)}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6">
                                            <div className="basic-info-detail">
                                                <h6>Total Working Time</h6>
                                                <p>{Data.total_workedTime}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

AttendanceView.propTypes = {
    Emp_data: PropTypes.object.isRequired,
};

export default AttendanceView;

